import PropTypes from "prop-types";

import Notifications from "./Notifications.jsx";
import Profile from "./Profile.jsx";

import "./styles.css";

const CustomHeader = ({ user }) => {
  return (
    <header className="base-header">
      <div className="base-header-content">
        <div className="base-header-content-notifications">
          <Notifications />
        </div>

        <div className="base-header-avatar">
          {user && <Profile currentUser={user} />}
        </div>
      </div>
    </header>
  );
};

CustomHeader.propTypes = {
  user: PropTypes.object.isRequired,
};

export default CustomHeader;
